import { requestf, requeste, requestk } from "../utils/request";

export const getApplication = async () => {
  const result = await requestf({
    url: "/application",
    method: "POST",
    data: {
      Application: "KE_APP",
    },
  });

  return result;
};

export const getBookings = async () => {
  // Receive
  const result = await requestf(
    {
      url: "/booking/GetBookings",
      method: "POST",
      data: {
        bookingStatus: "MDISP,MPREB,MPIN,MPINA,MPING,MTKA",
        perPage: 10,
        page: 1,
      },
    },
    "v3"
  );

  return result;
};

export const terminateMember = async (KcCustomerId) => {
  // Receive
  const result = await requestf(
    {
      url: "/members/terminate-member",
      method: "DELETE",
      data: {
        KcCustomerId,
      },
    },
    "v3"
  );

  return result;
};

export const getMemberInfo = async () => {
  // Receive
  const result = await requeste(
    {
      url: "/Loyalty/v3/Info",
      method: "POST",
    }
  );

  return result;
};

export const getAppMemberInfo = async () => {
  // Receive
  const result = await requestk(
    {
      url: "/Loyalty/Info",
    }, 'v7'
  );

  return result;
};

export const getThirdToken = async (data) => {
  const result = await requestf({
    url: "/third/auth/token",
    method: "POST",
	header: data
  });

  return result;
};

export const refreshToken = async (data) => {
  const result = await requestf({
    url: "/auth/refresh-token",
    method: "POST",
	data,
	hideLoading: true
  });

  return result;
};